import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=7d6a6350&scoped=true"
import script from "./confirmation.vue?vue&type=script&lang=ts"
export * from "./confirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6a6350",
  null
  
)

export default component.exports